<div class="row">
  <div class="col-10 col-sm-10">
    <h1 mat-dialog-title>{{data?.title ? data.title : ''}}</h1>
  </div>
  <div class="col-2 col-sm-2 text-right">
    <button mat-icon-button [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content>
  <ng-container *ngComponentOutlet="data.component"></ng-container>
</mat-dialog-content>
<!-- <mat-dialog-actions align="center">
  <button mat-button color="warn" [mat-dialog-close]="true">Close</button>
</mat-dialog-actions> -->